export const LOCAL_STORAGE_CART_KEY = 'unauthorized_cart';
export const MAX_CART_ITEMS = 100;
export const DEBOUNCE_SAVE_DELAY = 500;